import { useContext, useState } from "react";
import { ticketService } from "../../../services/api/ticketService";
import { AuthContext } from "../../../contexts/AuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import MobilePatternHeader from "../components/MobilePatternHeader";

const Support = ({ isMobile }) => {
  const navigate = useNavigate();

  const { token_client } = useContext(AuthContext);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    note: "",
  });

  const contact = [
    {
      image: "/icons/telephone.svg",
      alt: "telephone icon",
      title: "Điện thoại",
      text: "08.1900.9697",
    },
    {
      image: "/icons/email.svg",
      alt: "email icon",
      title: "Email",
      text: "dangky@sohuutritue.vn",
    },
    {
      image: "/icons/location.svg",
      alt: "location icon",
      title: "Địa chỉ",
      text: "Số 104/13 Nguyễn Thái Sơn, Phường Hạnh Thông, Thành phố Hồ Chí Minh, Việt Nam",
    },
  ];

  const formFormat = [
    {
      label: "Họ tên",
      type: "text",
      name: "fullName",
      placeholder: "Họ tên",
      value: formData.fullName,
    },
    {
      label: "Số điện thoại",
      type: "text",
      name: "phone",
      placeholder: "Số điện thoại",
      value: formData.phone,
    },
    {
      label: "Email",
      type: "email",
      name: "email",
      placeholder: "Nhập email",
      value: formData.email,
    },
    {
      label: "Lời nhắn",
      type: "textarea",
      name: "note",
      placeholder: "Để lại lời nhắn",
      value: formData.note,
      rows: 4,
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    const isValidPhone = (phone) => /^[0-9]{10,11}$/.test(phone);
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!isValidPhone(formData.phone)) {
      setIsSubmitting(false);
      toast.error("Số điện thoại không hợp lệ.");
      return;
    }

    if (!isValidEmail(formData.email)) {
      setIsSubmitting(false);
      toast.error("Email không hợp lệ.");
      return;
    }
    try {
      const catagory = "6773b5c494f2457c1b79e38b";
      await ticketService.create_ticket(
        catagory,
        formData.fullName,
        formData.phone,
        formData.email,
        formData.note,
        token_client
      );
      toast.success("Gửi thành công!");
      navigate("/danh-sach-yeu-cau");
    } catch (err) {
      console.error("Lỗi khi tạo ticket: ", err);
      toast.error("Xảy ra lỗi khi tạo ticket!");
    } finally {
      setIsSubmitting(false);
      setFormData({
        fullName: "",
        phone: "",
        email: "",
        note: "",
      });
    }
  };
  if (isMobile) {
    return (
      <div className="h-full w-full">
        <MobilePatternHeader
          title="Tạo mới yêu cầu"
          onBack={() => navigate(-1)}
        />
        <div className="h-[calc(100%-64px)] overflow-auto bg-[#F2F2F2] p-3">
          <div className="w-full bg-white rounded-lg flex items-center justify-between border border-[#EAEAEA]">
            <div className="flex flex-col gap-6 w-full">
              {/* Contact Information */}
              <div className="bg-white rounded-xl h-auto p-3 space-y-2">
                <p className="font-sf-semibold text-lg">Bạn cần trợ giúp?</p>
                <p className=" text-sm text-[#606060]">
                  We are here to assist you with any questions, concerns, or
                  issues you may have. Our dedicated support team is committed
                  to providing you with the best service.
                </p>
                <div className="space-y-3">
                  {contact.map((item, index) => (
                    <div
                      key={index}
                      className="border border-[#E1E5F3] rounded-lg flex justify-between items-center p-2"
                    >
                      <div className="flex items-center min-w-[50px]">
                        <img
                          src={item.image}
                          alt={item.alt}
                          className="object-contain"
                        />
                      </div>
                      <p className="font-sf-semibold text-sm text-right text-[#1C1A3C]">
                        {item.text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="w-full bg-white rounded-lg flex items-center justify-between border border-[#EAEAEA] mt-3">
            {/* Support Form */}
            <form
              className="w-full flex flex-col items-end"
              onSubmit={handleSubmit}
            >
              <div className="space-y-3 bg-white rounded-xl w-full h-auto p-3">
                {formFormat.map((input, index) => (
                  <div key={index} className="w-full flex flex-col space-y-2">
                    <label
                      htmlFor={input.name}
                      className="text-sm font-be-vietnam-medium"
                    >
                      {input.label}
                    </label>
                    {input.type === "textarea" ? (
                      <textarea
                        name={input.name}
                        id={input.name}
                        rows={input.rows}
                        placeholder={input.placeholder}
                        value={input.value}
                        onChange={handleChange}
                        className="w-full px-4 py-3 text-sm text-[#817F9B] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                        required
                      />
                    ) : (
                      <input
                        type={input.type}
                        name={input.name}
                        id={input.name}
                        placeholder={input.placeholder}
                        value={input.value}
                        autoComplete="off"
                        onChange={handleChange}
                        className="w-full px-4 py-3 text-sm text-[#817F9B] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                      />
                    )}
                  </div>
                ))}
              </div>
            </form>
          </div>
          <button
            type="submit"
            onClick={handleSubmit}
            disabled={isSubmitting}
            className={`bg-blue-500 p-[10px] mb-20 font-sf-medium mt-3 w-full text-white rounded-lg ${isSubmitting ? "opacity-50 cursor-default" : "hover:bg-blue-600"
              }`}
          >
            {isSubmitting ? "Đang gửi..." : "Gửi ngay"}
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col lg:flex-row gap-6 h-full overflow-auto">
      {/* Contact Information */}
      <div className="lg:w-1/2 bg-white rounded-[16px] border border-[#D2D5DA] p-4 h-auto lg:h-[455px]">
        <p className="font-sf-semibold text-xl">Bạn cần trợ giúp?</p>
        <p className="mt-4 text-sm text-[#606060]">
          We are here to assist you with any questions, concerns, or issues you
          may have. Our dedicated support team is committed to providing you
          with the best service.
        </p>
        <div className="mt-8 space-y-6">
          {contact.map((item, index) => (
            <div
              key={index}
              className="border border-[#E1E5F3] rounded-lg flex justify-between items-center p-4"
            >
              <div className="flex items-center gap-3 min-w-[100px]">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="object-contain"
                />
                <p className="text-sm whitespace-nowrap">{item.title}</p>
              </div>
              <p className="font-sf-semibold text-sm text-right text-[#1C1A3C]">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Support Form */}
      <form
        className="lg:w-1/2 flex flex-col items-end bg-white rounded-[16px] border border-[#D2D5DA] p-4 h-auto"
        onSubmit={handleSubmit}
      >
        <div className="space-y-4 bg-white rounded-xl w-full h-auto lg:h-[455px] py-6 px-8">
          {formFormat.map((input, index) => (
            <div key={index} className="w-full flex flex-col space-y-2">
              <label htmlFor={input.name} className="text-sm">
                {input.label}
              </label>
              {input.type === "textarea" ? (
                <textarea
                  name={input.name}
                  id={input.name}
                  rows={input.rows}
                  placeholder={input.placeholder}
                  value={input.value}
                  onChange={handleChange}
                  className="w-full px-4 py-3 text-sm text-[#817F9B] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                  required
                />
              ) : (
                <input
                  type={input.type}
                  name={input.name}
                  id={input.name}
                  placeholder={input.placeholder}
                  value={input.value}
                  autoComplete="off"
                  onChange={handleChange}
                  className="w-full px-4 py-3 text-sm text-[#817F9B] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              )}
            </div>
          ))}
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className={`bg-blue-500 p-[10px] font-sf-medium mt-6 text-white rounded-lg ${isSubmitting ? "opacity-50 cursor-default" : "hover:bg-blue-600"
            }`}
        >
          {isSubmitting ? "Đang gửi..." : "Gửi ngay"}
        </button>
      </form>
    </div>
  );
};

export default Support;
